export default __webpack_public_path__ + "static/media/752.530c8191.gif";